<template>
  <ListPC v-if="isPc"></ListPC>
  <div v-else class="list-page">
    <loading ref="loading" />
    <!--视频播放弹窗-->
    <cube-popup type="my-popup" ref="myPopup">
      <video :src="play_address" width="100%" height="240" controls>
        Your browser does not support the video tag.
      </video>
    </cube-popup>

    <!-- 顶部 -->
    <div class="list-hero">
      <div class="list-header">
        <i class="cubeic-back" @click="goBack"></i>
        <h1 class="list-title">课程中心</h1>
        <span class="list-placeholder"></span>
      </div>
      <div class="list-search">
        <span class="list-search-icon">&#128269;</span>
        <input
          class="list-search-input"
          v-model="keyword"
          type="text"
          placeholder="搜索目录..."
          @input="onSearchInput"
        />
      </div>
    </div>

    <div class="list-body">
      <!-- 分类目录 -->
      <div class="list-section" v-if="project && project.length > 0">
        <h2 class="list-section-title">
          <span class="list-section-bar"></span>
          课程目录
        </h2>
        <div class="list-category-grid">
          <div
            v-for="(item, index) in project"
            :key="index"
            class="list-category-card"
            @click="goToList(item.id)"
          >
            <div class="list-category-icon">
              <img src="../assets/images/icon-item-003.png" alt />
            </div>
            <div class="list-category-info">
              <span class="list-category-name">{{ item.name }}</span>
              <span class="list-category-desc" style="margin-top: 3px">{{ item.video_count }}个课程</span>
            </div>
            <span class="list-category-arrow">&gt;</span>
          </div>
        </div>
      </div>

      <!-- 视频列表 -->
      <div class="list-section" v-if="videos && videos.length > 0">
        <h2 class="list-section-title">
          <span class="list-section-bar"></span>
          视频课程
        </h2>
        <div class="list-video-list">
          <div
            v-for="(video, index) in videos"
            :key="index"
            class="list-video-card"
            @click="sendVideoIaram(video)"
          >
            <div class="list-video-left">
              <div class="list-video-play-icon">&#9654;</div>
              <div class="list-video-thumb">
                <img src="../assets/images/icon-item-002.png" alt />
              </div>
            </div>
            <div class="list-video-info">
              <h3 class="list-video-name">{{ video.name }}</h3>
              <div class="list-video-tags">
                <span class="list-video-tag">视频课程</span>
                <span class="list-video-duration">在线播放</span>
              </div>
            </div>
            <span class="list-category-arrow">&gt;</span>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div class="list-empty" v-if="(!project || project.length === 0) && (!videos || videos.length === 0)">
        <img src="../assets/images/empty.png" alt="暂无内容" class="list-empty-img" />
        <p class="list-empty-text">暂无课程内容</p>
        <p class="list-empty-sub">请稍后再来查看</p>
      </div>
    </div>
  </div>
</template>

<script>
import { get_class, get_videos, set_click_rate } from "@/api/category";
import bus from '../services/bus';
import loading from "@/views/loading";
import ListPC from "./ListPC.vue";

export default {
  components: { loading, ListPC },
  data() {
    return {
      project: [],
      videos: [],
      play_address: '',
      keyword: '',
      searchTimer: null,
      isPc: false
    };
  },
  async created() {
    this.isPc = this.IsPCVisted();
  },
  mounted() {
    if (!this.isPc) this.get_resources(this.$route.params.id);
  },
  methods: {
    getBuketType() {
      return '1'
    },
    async get_resources(id) {
      this.$refs['loading'].showPopups();
      const [catRes, videoRes] = await Promise.all([
        get_class(id, this.keyword).catch(() => ({ data: { data: [] } })),
        get_videos(id, this.keyword).catch(() => ({ data: { data: [] } }))
      ]);
      const categorys = catRes.data.data;
      const videos = videoRes.data.data;
      this.project = Array.isArray(categorys) ? categorys : Object.values(categorys || {});
      this.videos = Array.isArray(videos) ? videos : Object.values(videos || {});
      this.loaded = true;
      this.$refs['loading'].hidePopups();
    },
    doSearch() {
      this.get_resources(this.$route.params.id);
    },
    onSearchInput() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.get_resources(this.$route.params.id);
      }, 300);
    },
    showPopup(refId, link, id) {
      const component = this.$refs[refId];
      component.show();
      this.play_address = link;
      set_click_rate(id);
    },
    goBack() {
      this.$router.go(-1);
    },
    sendVideoIaram(obj) {
      set_click_rate(obj.id);
      bus.$emit('getParam', obj);
      this.$router.push(`/video/${obj.id}/${this.getBuketType()}?categoryId=${this.$route.params.id}`);
    },
    goToList(categoryId) {
      this.$router.push(`/list/${categoryId}`);
    },
    IsPCVisted() {
      if (window.innerWidth < 768) return false;
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod", "Mobi", "Mobile"];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) !== -1) return false;
      }
      return true;
    },
    onNavigate(path) {
      this.$router.push(path);
    }
  },
  watch: {
    $route: {
      handler: function() {
        this.keyword = '';
        this.get_resources(this.$route.params.id);
      }
    }
  }
};
</script>

<style scoped>
@import "../assets/stytels/list.css";

.list-page {
  background: #f4f6fb;
  min-height: 100vh;
  padding-bottom: 30px;
}

.list-hero {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  padding: 24px 16px 24px;
  position: relative;
  overflow: hidden;
}

.list-hero::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(102, 126, 234, 0.12) 0%, transparent 70%);
  border-radius: 50%;
}

.list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.list-header .cubeic-back {
  font-size: 22px;
  color: rgba(255, 255, 255, 0.85);
  padding: 4px 8px 4px 0;
}

.list-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  letter-spacing: 0.5px;
}

.list-placeholder {
  width: 30px;
}

.list-search {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 9px 16px;
  margin-top: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  z-index: 1;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.list-search-icon {
  font-size: 14px;
  opacity: 0.5;
  filter: brightness(0) invert(1);
}

.list-search-text {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
}

.list-body {
  padding: 0 16px;
}

.list-section {
  margin-top: 22px;
}

.list-section-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.list-section-bar {
  display: inline-block;
  width: 3px;
  height: 15px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 2px;
  flex-shrink: 0;
}

.list-category-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.list-category-card {
  background: #fff;
  border-radius: 14px;
  padding: 16px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  transition: transform 0.2s ease;
}

.list-category-card:active {
  transform: scale(0.97);
}

.list-category-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.list-category-icon img {
  width: 60%;
  height: 60%;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.list-category-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: flex-start;
  padding-left: 10px;
}

.list-category-name {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-category-desc {
  font-size: 11px;
  color: #999;
}

.list-category-arrow {
  font-size: 14px;
  color: #ccc;
  font-weight: bold;
  flex-shrink: 0;
}

.list-video-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.list-video-card {
  background: #fff;
  border-radius: 14px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  transition: transform 0.2s ease;
}

.list-video-card:active {
  transform: scale(0.98);
}

.list-video-left {
  position: relative;
  flex-shrink: 0;
}

.list-video-thumb {
  width: 72px;
  height: 54px;
  border-radius: 10px;
  background: linear-gradient(135deg, #e8edf5, #d5dce8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.list-video-thumb img {
  width: 50%;
  height: 50%;
  object-fit: contain;
  opacity: 0.5;
}

.list-video-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(102, 126, 234, 0.9);
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  padding-left: 2px;
}

.list-video-info {
  flex: 1;
  min-width: 0;
}

.list-video-name {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 6px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
  text-align: left;
}

.list-video-tags {
  display: flex;
  gap: 8px;
  align-items: center;
}

.list-video-tag {
  font-size: 11px;
  color: #667eea;
  background: #eef0ff;
  padding: 2px 8px;
  border-radius: 8px;
}

.list-video-duration {
  font-size: 11px;
  color: #bbb;
}

.list-empty {
  text-align: center;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.list-empty-img {
  width: 50%;
  max-width: 160px;
  margin-bottom: 16px;
  opacity: 0.7;
}

.list-empty-text {
  font-size: 16px;
  font-weight: 600;
  color: #999;
  margin: 0 0 6px;
}

.list-empty-sub {
  font-size: 13px;
  color: #ccc;
  margin: 0;
}

.list-search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 13px;
  caret-color: #667eea;
}

.list-search-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.list-search-icon {
  cursor: pointer;
}
</style>
